// import React, { useState } from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = () => {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const location = useLocation();

//   const navLinks = [
//     { name: 'Home', path: '/' },
//     { name: 'Find Doctors', path: '/doctors' },
//     { name: 'Blog', path: '/blog' },
//   ];

//   const isActive = (path) => location.pathname === path;

//   return (
//     <nav className="bg-[#19354a] shadow-lg fixed w-full top-0 z-50">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="flex justify-between items-center h-20">

//           {/* Logo */}
//           <Link to="/" className="flex items-center">
//             <span className="text-2xl font-bold">
//               <span className="text-white">Doc</span>
//               <span className="text-[#39a5d3]">mize</span>
//             </span>
//           </Link>

//           {/* Desktop Navigation */}
//           <div className="hidden md:flex items-center space-x-8">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`font-semibold transition-colors text-sm ${
//                   isActive(link.path)
//                     ? 'text-[#39a5d3]'
//                     : 'text-white hover:text-[#39a5d3]'
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             ))}
//           </div>

//           {/* Right Side */}
//           <div className="hidden md:flex items-center gap-6">

//             {/* Phone number */}
//             <a
//               href="tel:+918920845297"
//               className="flex items-center gap-2 text-white hover:text-[#39a5d3] transition-colors"
//             >
//               <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />
//               </svg>
//               <span className="text-sm font-semibold">+91 89208 45297</span>
//             </a>

//             {/* Divider */}
//             <div className="w-px h-5 bg-white opacity-30" />

//             {/* Book Appointment — same style as phone */}
//             <Link
//               to="/book-appointment"
//               className="flex items-center gap-2 text-white hover:text-[#39a5d3] transition-colors"
//             >
//               <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
//               </svg>
//               <span className="text-sm font-semibold">Book Appointment</span>
//             </Link>
//           </div>

//           {/* Mobile Menu Button */}
//           <button
//             onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//             className="md:hidden text-white focus:outline-none"
//           >
//             <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               {isMobileMenuOpen ? (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//               ) : (
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//               )}
//             </svg>
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {isMobileMenuOpen && (
//           <div className="md:hidden pb-4 border-t border-white border-opacity-10 pt-3">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 onClick={() => setIsMobileMenuOpen(false)}
//                 className={`block py-2 font-semibold text-sm transition-colors ${
//                   isActive(link.path)
//                     ? 'text-[#39a5d3]'
//                     : 'text-white hover:text-[#39a5d3]'
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             ))}
//             <a
//               href="tel:+918920845297"
//               className="flex items-center gap-2 py-2 text-white text-sm font-semibold"
//             >
//               <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />
//               </svg>
//               +91 89208 45297
//             </a>
//             <Link
//               to="/book-appointment"
//               onClick={() => setIsMobileMenuOpen(false)}
//               className="block mt-3 px-4 py-2 rounded-lg text-sm font-bold text-center text-white"
//               style={{ background: '#E85A2C' }}
//             >
//               Book Appointment
//             </Link>
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000';
const today = new Date().toISOString().split('T')[0];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [loading, setLoading] = useState(false);
  const lastScrollY = useRef(0);
  const location = useLocation();

  const [form, setForm] = useState({ name:'', email:'', phone:'', appointmentDate:'', message:'' });

  useEffect(() => {
    const onScroll = () => {
      const current = window.scrollY;
      if (current < 10) setVisible(true);
      else if (current > lastScrollY.current) { setVisible(false); setMobileOpen(false); }
      else setVisible(true);
      lastScrollY.current = current;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  const isActive = (path) => location.pathname === path;

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/bookings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          patientName:     form.name.trim(),
          patientPhone:    form.phone.trim(),
          patientEmail:    form.email.trim(),
          appointmentDate: form.appointmentDate,
          message:         form.message.trim(),
          source: 'navbar',
        }),
      });
      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        setSubmitError(data.message || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setSubmitError('Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setSubmitted(false);
    setSubmitError('');
    setLoading(false);
    setForm({ name:'', email:'', phone:'', appointmentDate:'', message:'' });
  };

  const inputStyle = {
    width:'100%', padding:'10px 14px', fontSize:13, color:'#333',
    border:'1px solid #dde3ea', borderRadius:8, outline:'none',
    background:'#f9fafb', boxSizing:'border-box', fontFamily:'inherit',
  };

  const NavLink = ({ label, path }) => (
    <Link to={path} className={`font-semibold text-sm transition-all whitespace-nowrap ${
      isActive(path) ? 'text-[#39a5d3]' : 'text-[#19354a] hover:text-[#39a5d3]'
    }`}>
      {label}
    </Link>
  );

  return (
    <>
      {/* ── DESKTOP — Floating pill ── */}
      <nav className={`fixed top-4 left-0 right-0 z-50 hidden md:flex justify-center px-4 transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}>
        <div className="flex items-center justify-between bg-white shadow-lg rounded-full border border-slate-100 px-6 py-2.5" style={{ width: 680 }}>
          <div className="flex items-center gap-6">
            <NavLink label="Home" path="/" />
            <NavLink label="Find Doctors" path="/doctors" />
          </div>
          <Link to="/" className="flex items-center justify-center hover:opacity-80 transition-opacity">
            <img src="/images/Logo.png" alt="Docmize" style={{ height: 34, width: 'auto', objectFit: 'contain', mixBlendMode: 'multiply', display: 'block' }} />
          </Link>
          <div className="flex items-center gap-6">
            <NavLink label="Blog" path="/blog" />
            <button onClick={() => setShowModal(true)}
              className="bg-[#19354a] hover:bg-[#152d3f] text-white font-semibold text-sm px-4 py-2 rounded-full transition-all flex items-center gap-2 whitespace-nowrap"
              style={{ border:'none', cursor:'pointer', fontFamily:'inherit' }}>
              <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Book Appointment
            </button>
          </div>
        </div>
      </nav>

      {/* ── MOBILE ── */}
      <nav className={`fixed top-0 left-0 right-0 z-50 md:hidden transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      }`}>
        <div className="flex items-center justify-between bg-white shadow-md px-5 py-3 border-b border-slate-100">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img src="/images/Logo.png" alt="Docmize" className="h-9 w-auto object-contain" style={{ mixBlendMode:'multiply' }} />
          </Link>
          <button onClick={() => setMobileOpen(v => !v)} className="p-2 rounded-xl hover:bg-slate-100 transition-colors">
            <svg className="w-5 h-5 text-slate-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
            </svg>
          </button>
        </div>
        {mobileOpen && (
          <div className="bg-white border-t border-slate-100 shadow-lg px-4 pb-4 flex flex-col gap-1">
            {[{ label:'Home', path:'/' }, { label:'Find Doctors', path:'/doctors' }, { label:'Blog', path:'/blog' }].map(({ label, path }) => (
              <Link key={path} to={path}
                className={`px-4 py-3 rounded-xl font-semibold text-sm transition-colors ${
                  isActive(path) ? 'bg-blue-50 text-[#39a5d3]' : 'text-slate-700 hover:bg-slate-50'
                }`}>
                {label}
              </Link>
            ))}
            <div className="border-t border-slate-100 mt-2 pt-3 flex flex-col gap-2">
              <a href="tel:+918920845297" className="flex items-center gap-2 px-4 py-3 text-slate-700 font-semibold text-sm rounded-xl hover:bg-slate-50">
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z" />
                </svg>
                +91 89208 45297
              </a>
              <button onClick={() => { setShowModal(true); setMobileOpen(false); }}
                className="flex items-center justify-center gap-2 px-4 py-3 bg-[#19354a] text-white rounded-xl text-sm font-bold"
                style={{ border:'none', cursor:'pointer', fontFamily:'inherit' }}>
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Book Appointment
              </button>
            </div>
          </div>
        )}
      </nav>

      {/* ── BOOKING MODAL ── */}
      {showModal && (
        <>
          <div onClick={closeModal} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', zIndex:1000 }} />
          <div style={{
            position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)',
            background:'#fff', borderRadius:16, width:'100%', maxWidth:480,
            zIndex:1001, boxShadow:'0 20px 60px rgba(0,0,0,0.2)', maxHeight:'90vh', overflowY:'auto',
          }}>
            <div style={{ padding:'22px 28px 16px', borderBottom:'1px solid #eee', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <h2 style={{ fontSize:18, fontWeight:700, color:'#19354a', margin:0 }}>Book Appointment</h2>
              <button onClick={closeModal} style={{ background:'none', border:'none', cursor:'pointer', color:'#888', padding:4 }}>
                <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div style={{ padding:'20px 28px 28px' }}>
              {submitted ? (
                <div style={{ textAlign:'center', padding:'20px 0' }}>
                  <div style={{ width:56, height:56, borderRadius:'50%', background:'#e8f7ee', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px' }}>
                    <svg width="24" height="24" fill="none" stroke="#2e7d32" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h3 style={{ fontSize:17, fontWeight:700, color:'#19354a', marginBottom:8 }}>Request Received!</h3>
                  <p style={{ fontSize:13, color:'#666', lineHeight:1.7, marginBottom:20 }}>
                    Thank you, <strong>{form.name}</strong>. Our team will call you on <strong>{form.phone}</strong> within 24 hours.
                    {form.email && <> A confirmation has been sent to <strong>{form.email}</strong>.</>}
                  </p>
                  <button onClick={closeModal} style={{ background:'#19354a', color:'#fff', border:'none', borderRadius:8, padding:'10px 28px', fontSize:14, fontWeight:600, cursor:'pointer', fontFamily:'inherit' }}>
                    Done
                  </button>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom:14 }}>
                    <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name *" required style={inputStyle} />
                  </div>
                  <div style={{ marginBottom:14 }}>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone Number *" type="tel" required style={inputStyle} />
                  </div>
                  <div style={{ marginBottom:14 }}>
                    <input name="email" value={form.email} onChange={handleChange} placeholder="Email (optional)" type="email" style={inputStyle} />
                  </div>
                  <div style={{ marginBottom:14 }}>
                    <label style={{ fontSize:11, color:'#888', display:'block', marginBottom:5 }}>Preferred Date *</label>
                    <input name="appointmentDate" value={form.appointmentDate} onChange={handleChange} type="date" min={today} required style={inputStyle} />
                  </div>
                  <div style={{ marginBottom:20 }}>
                    <textarea name="message" value={form.message} onChange={handleChange} placeholder="Message (optional)" rows={3} style={{ ...inputStyle, resize:'none', lineHeight:1.6 }} />
                  </div>
                  {submitError && (
                    <div style={{ background:'#fff5f5', border:'1px solid #ffcccc', borderRadius:6, padding:'10px 14px', fontSize:13, color:'#c0392b', marginBottom:14 }}>
                      {submitError}
                    </div>
                  )}
                  <button type="submit" disabled={loading} style={{ width:'100%', background: loading ? '#a8d8ee' : '#19354a', color:'#fff', border:'none', borderRadius:8, padding:'12px 0', fontSize:14, fontWeight:700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily:'inherit' }}>
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;